import {
  About1,
  About2,
  Sample,
  SampleHero,
  AboutHero as AboutHero1,
} from "../../../assets/images";
import Col from "../../../components/element/col";
import Container from "../../../components/element/container";
import Image from "../../../components/element/image";
import Row from "../../../components/element/row";

export default function AboutHero() {
  return (
    // <Container className="about-hero">
    //   <Row>
    //     <h1 className="_label about-title">About Our Story</h1>
    //   </Row>
    //   <Row className="_row about-content">
    //     <Image src={About1} className="_img left" />
    //     <Col className="v-flex justify-between h-100">
    //       <p className="_label about-subtitle">
    //         Explore our collection and find <br /> cloths that speaks to you
    //       </p>
    //       <p className="_label about-description">
    //         The journey behind DC Fashion's evolution in modern fashion
    //       </p>
    //     </Col>
    //   </Row>
    //   <Image src={About2} className="_img right" />
    // </Container>
    <Container className="about-hero">
      <Image src={AboutHero1} className="_img hero" />
    </Container>
  );
}
